/** Хост content API для новостей (как раньше в NewsStore / баннерах). */
export const getNewsApiBaseUrl = (): string => 'https://nest.sellwin.by';

/** iframe: nest file-proxy обходит CORS/X-Frame портала */
export const getNewsFileSrc = (item: {file_proxy?: string; file?: string} | null | undefined): string => {
    if (!item) return '';
    if (item.file_proxy) {
        return `${getNewsApiBaseUrl()}${item.file_proxy}`;
    }
    return item.file || '';
};
